import { render, staticRenderFns } from "./AddPartenaire.vue?vue&type=template&id=51937c2e&"
import script from "./AddPartenaire.vue?vue&type=script&lang=ts&"
export * from "./AddPartenaire.vue?vue&type=script&lang=ts&"
import style0 from "./AddPartenaire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports